import { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { findGuide } from './constants/guides';
import { SITE_NAME } from './constants/site';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CookiePolicy from './pages/CookiePolicy';
import DisclaimerPage from './pages/DisclaimerPage';
import FaqsPage from './pages/FaqsPage';
import GuideArticlePage from './pages/GuideArticlePage';
import GuidesPage from './pages/GuidesPage';
import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import HelpsServicesPage from './pages/HelpsServicesPage';
import TermsPage from './pages/TermsPage';
import TroubleshootingPage from './pages/TroubleshootingPage';
import UpdatesPage from './pages/UpdatesPage';

const PAGE_TITLES = {
  '/': `${SITE_NAME} | Independent Ancestry Help, Updates & Troubleshooting`,
  '/troubleshooting': `Troubleshooting | ${SITE_NAME}`,
  '/updates': `Updates Hub | ${SITE_NAME}`,
  '/helps-services': `Helps Services | ${SITE_NAME}`,
  '/guides': `Free Guides | ${SITE_NAME}`,
  '/faqs': `FAQs | ${SITE_NAME}`,
  '/about-us': `About Us | ${SITE_NAME}`,
  '/contact-us': `Contact Us | ${SITE_NAME}`,
  '/privacy-policy': `Privacy Policy | ${SITE_NAME}`,
  '/terms-and-conditions': `Terms & Conditions | ${SITE_NAME}`,
  '/refund-policy': `Refund Policy | ${SITE_NAME}`,
  '/cookie-policy': `Cookie Policy | ${SITE_NAME}`,
  '/disclaimer': `Disclaimer | ${SITE_NAME}`,
};

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const guide = pathname.startsWith('/guides/') && findGuide(pathname.slice(8));
    document.title = guide ? `${guide.title} | ${SITE_NAME}` : PAGE_TITLES[pathname] || `Page Not Found | ${SITE_NAME}`;
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <DocumentTitle />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/troubleshooting" element={<TroubleshootingPage />} />
        <Route path="/updates" element={<UpdatesPage />} />
        <Route path="/helps-services" element={<HelpsServicesPage />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/guides/:slug" element={<GuideArticlePage />} />
        <Route path="/faqs" element={<FaqsPage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
